import ArrowLeftIcon from '@euler/assets/arrow-left.svg';
import ArrowRightIcon from '@euler/assets/arrow-right.svg';
import { usePersistFn } from '@euler/utils/hooks';
import { memo } from 'react';
import { TouchableOpacity } from 'react-native';
import * as Shared from './HorizontalScrollButton.shared';

export const HorizontalScrollButton = memo(
  ({ type, style, size = 30, onPress }: Shared.Props) => {
    const handlePress = usePersistFn(() => {
      onPress?.(type);
    });
    return (
      <TouchableOpacity
        onPress={handlePress}
        css={`
          align-items: center;
          justify-content: center;
        `}
        style={style}
      >
        {type === 'left' ? (
          <ArrowLeftIcon width={size} height={size} viewBox={'0 0 60 60'} />
        ) : (
          <ArrowRightIcon width={size} height={size} viewBox={'0 0 60 60'} />
        )}
      </TouchableOpacity>
    );
  },
);
